import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatExpansionModule } from '@angular/material/expansion';
import { MaterialCommonModule } from 'src/app/material-modules/material-common.module';
import { ComboPesquisavelModule } from '../combo-pesquisavel/combo-pesquisavel.module';
import { ComboMetaAtendimentoComponent } from './combo-meta-atendimento.component';



@NgModule({
  declarations: [ComboMetaAtendimentoComponent],
  imports: [
    CommonModule,
    MaterialCommonModule,
    MatExpansionModule,
    ComboPesquisavelModule
  ],
  exports:[ComboMetaAtendimentoComponent]
})
export class ComboMetaAtendimentoModule { }
